import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedAdminRoute = ({ children }) => {
    const userRole = localStorage.getItem('role') || null; // Get the user role from localStorage

    if (userRole?.toLowerCase() !== 'admin') {
        return <Navigate to="/login" />;
    }

    return children;
};

export default ProtectedAdminRoute;